// extracted by mini-css-extract-plugin
module.exports = {"spec":"specs_spec__05K3g"};